import { render, staticRenderFns } from "./document-content.vue?vue&type=template&id=06d6bc90"
import script from "./document-content.vue?vue&type=script&lang=js"
export * from "./document-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports